module.exports = __webpack_public_path__ + "assets/9a4bbfd0e30e9e94e3db4981f6b69ea5.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./public-src/sounds/randWilds/WolfJump.mp3
 ** module id = 383
 ** module chunks = 0
 **/